<template>
  <Layout>
    <Aguarde :show="httpSend"></Aguarde>
    <PageHeader :title="title" :items="items"/>
    <div v-if="empresa && empresa.eco_codigo" class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div v-if="empresa.pes_cpfcnpj" class="row">
              <div class="col-md-6">
                <div class="media">
                  <div class="media-body align-self-center">
                    <div class="text-muted">
                      <h5 class="mb-1">{{ empresa.pes_nome }}</h5>
                      <p class="mb-0" v-if="empresa.pes_cpfcnpj.length < 12">
                        {{ empresa.pes_cpfcnpj | VMask('###.###.###-##') }}</p>
                      <p class="mb-0" v-else>{{ empresa.pes_cpfcnpj | VMask('##.###.###/####-##') }}</p>
                      <p class="mb-0">{{ empresa.eco_nome_fantasia }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="divergencias && divergencias.length > 0" class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="row">
            <div class="col-sm-12">
              <div class="p-3">
                <h5 class="text-danger">Períodos com Divergência</h5>
                <div class="row">
                  <div class="col-sm-12">
                    <span v-for="d in divergencias" :key="d.esr_competencia">
                      <button type="button" @click="sel_periodo(d.esr_competencia)" title="Verificar pagamentos" class="btn btn-label btn-sm ml-2 mb-3 btn-danger"><i class="bx bx-error label-icon"></i> {{d.esr_competencia.slice(4, 6) | monthNames }} de {{ d.esr_competencia.slice(0, 4) }}</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <div class="row">
                <div class="col-sm-12">
                  <div class="float-left">
                    <div class="input-group input-group-sm">
                      <select @change="alter_ano()" v-model="filtro.ano" class="custom-select custom-select-sm">
                        <option v-for="([a, m], index) in periodos" :key="index" v-bind:value="index">{{
                            index
                          }}
                        </option>
                      </select>
                      <select v-model="filtro.mes" class="custom-select custom-select-sm">
                        <option v-for="m in meses" :key="m" v-bind:value="m">{{ m | monthNames }}</option>
                      </select>
                      <div class="input-group-append">
                        <button type="button" @click="apuracao_simples()" class="btn btn-primary"><i
                            class="bx bx-check-double"></i> Verificar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-3">
                <b-tabs v-model="tabIndex" justified nav-class="nav-tabs-custom" content-class="text-muted">
                  <b-tab active>
                    <template v-slot:title>
                      <span>Apuração</span>
                    </template>
                    <SimplesApuracao :eco_codigo="empresa.eco_codigo" :competencia="competencia"
                                     ref="apuracao"></SimplesApuracao>
                  </b-tab>
                  <b-tab>
                    <template v-slot:title>
                      <span>DAS-D</span>
                    </template>
                    <SimplesDas :eco_codigo="empresa.eco_codigo" :competencia="competencia"
                                :pes_cpfcnpj="empresa.pes_cpfcnpj" ref="das"></SimplesDas>
                  </b-tab>
                  <b-tab>
                    <template v-slot:title>
                      <span>NFS-e</span>
                    </template>
                    <SimplesNfse :eco_codigo="empresa.eco_codigo" :competencia="competencia" ref="nfse"></SimplesNfse>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/dados/app.config.json";
import Layout from "../../../layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import PageHeader from "@/components/page-header";
import SimplesApuracao from "@/router/views/contribuinte/simples/components/simples-apuracao";
import SimplesDas from "@/router/views/contribuinte/simples/components/simples-das";
import SimplesNfse from "@/router/views/contribuinte/simples/components/simples-nfse";
import {listPeriodoDivergencia} from "@/api/simples_nacional/apuracao";
import {notifyAviso} from "@/helps/notificacao";

export default {
  page: {
    title: "Fiscalização do Simples Nacional",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Aguarde,
    PageHeader,
    SimplesApuracao,
    SimplesDas,
    SimplesNfse
  },
  data() {
    return {
      title: "Fiscalização do Simples Nacional",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Simples Nacional',
          href: '/contribuinte/simples/fiscalizacao',
        },
        {
          text: 'Fiscalização',
          active: true,
        },
      ],
      httpSend: false,
      ano_incial: null,
      mes_inicial: null,
      anos: [],
      meses: [],
      filtro: {
        ano: new Date().getFullYear().toString(),
        mes: String((new Date().getMonth() + 1)).padStart(2, '0')
      },
      tabIndex: 0,
      divergencias: [],
      periodos: []
    };
  },
  created() {
    if (!this.empresa || !this.empresa.eco_tributacao) {
      notifyAviso("Nenhuma empresa selecionada", "Selecione uma empresa")
      this.$router.push({name: 'painel'})
    } else {
      this.periodo_divergente()
    }
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
    competencia: {
      get: function () {
        const mes = String(this.filtro.mes).padStart(2, "0");
        return this.filtro.ano + mes;
      }
    }
  },
  watch: {
    tabIndex(newTab) {
      if (newTab === 1) {
        this.$refs.das.list_declaracao();
      }
      if (newTab === 2) {
        this.$refs.nfse.list_notas_simples();
      }
    }
  },
  methods: {
    alter_ano() {
      this.meses = this.periodos[this.filtro.ano];
    },
    sel_periodo(competencia) {
      const ano = String(competencia).slice(0, 4)
      const mes = String(competencia).slice(4, 6)
      this.filtro.ano = ano;
      this.filtro.mes = parseInt(mes)
      setTimeout(() => this.apuracao_simples(), 500);
    },
    periodo_divergente() {
      this.httpSend = true;
      listPeriodoDivergencia(this.empresa.eco_codigo).then(result => {
        const d = result.dados;
        this.ano_incial = d.ano_inicial;
        this.mes_inicial = d.mes_inicial;
        this.anos = d.anos;
        this.divergencias = d.apuracoes;
        this.periodos = d.periodos;
        this.filtro.ano = Math.max(...Object.keys(this.periodos).map(Number));
        this.filtro.mes = Math.max(...this.periodos[this.filtro.ano].map(Number));
        this.alter_ano()
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    apuracao_simples() {
      this.$refs.apuracao.list_apuracao();
      this.$refs.das.list_declaracao();
      this.$refs.nfse.list_notas_simples();
    }
  }
};
</script>

<style scoped>
.custom-select {
  min-width: 100px;
}
</style>
